// extracted by mini-css-extract-plugin
export var logocontainer = "logo-module--logocontainer--xMFeC";